export function registerOfflinePageServiceWorker() {
  if (navigator.serviceWorker) {
    navigator.serviceWorker.register('/offline-page-sw.js').catch(function(error) {
      console.log('offline-page-sw service worker registration failed:', error);
    });
  }
}

export function updateServiceWorker() {
  if (navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      registrations.forEach(function(registration) {
        registration.update();
      });
    });
  }
}
